export default {
  updateNationsGL(state, payload) {
    state.Nations = payload;
  },

  updateNationsEmployee(state, payload) {
    state.NationsEmployee = payload;
  },
  updateRoles(state, payload) {
    state.Roles = payload;
  },

  updatePartners(state, payload) {
    state.Partners = payload;
  },

  updatePartnerNations(state, payload) {
    Array.from(payload).forEach((item) => {
      state.PartnerNations.push(item);
    });
    state.PartnerNations = [
      ...Array.from(
        new Set(state.PartnerNations.map((item) => item.value)) // Lấy danh sách các 'id' duy nhất
      ).map((id) => state.PartnerNations.find((item) => item.value === id)),
    ];
  },

  updatePartnerEmployees(state, payload) {
    state.PartnerEmployees = payload;
  },
  
  updateRequestEmployees(state, payload) {
    state.RequestEmployees = payload;
  },
  
  updateAllNations(state, payload) {
    state.AllNations = payload;
  },
};
